import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ContentfulService } from '../contentful/contentful.service';

@Injectable()
export class TranslateLoaderService {
  constructor(@Inject(ContentfulService) private _ContentfulService: ContentfulService) {}

  public getTranslation(lang: string): Observable<any> {
    return this._ContentfulService.getBasicTranslation(lang);
  }
}
